export enum OwnershipCompositeServiceEnum {
    VehicleOwnership = 0,
    Customer = 1,
    Vehicle = 2,
    Registration = 3,
    Title = 4,
    Insurance = 5,
    InsuranceAllPolicyVehicles = 6,
    InsuranceReported = 7
}
